import {css} from 'styled-components'

export const textStyles = css`
  font-size: 0.8rem;
  user-select: none;
  pointer-events: none;
  position: absolute;
`
